import React, {useState, useEffect, useRef, Suspense} from 'react';
import { Tabs, Tab, Paper, withStyles, Typography, Box } from '@material-ui/core';
import { connect } from 'react-redux';
import { updateURL } from "../../sc-utilities";
import { CancelToken } from 'axios';
import * as actions from '../../sc-customer/Customer/store/customerActions';
import * as prepaidBalanceActions from '../PrepaidBalance/store/prepaidBalanceActions';
import CustomerEdit from '../../sc-customer/Customer/Details/CustomerEdit';
import * as billingAccountActions from '../../sc-billing/BillingAccount/store/billingAccountActions';
import Balance from '../PrepaidBalance';
import AccountOverview from '../../sc-billing/BillingAccount/Details/AccountOverview';
import * as billingActions from '../../sc-billing/BillingAccount/store/billingAccountActions';
import * as action from '../../np-core/Auth/store/authActions';
import moment from 'moment/moment.js'
import {hasPermission} from "../../sc-utilities";
import CircularProgress from "@material-ui/core/CircularProgress";

const PlanList = React.lazy(async () => await import('../../sc-billing/BillingAccount/Details/Plans'));
const SoftwareLicenseList = React.lazy(async () => await import('../../sc-billing/BillingAccount/Details/SoftwareLicense'));

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        paddingTop: 0,
        paddingRight: theme.spacing(2),
        paddingBottom: 0,
        margin: theme.spacing(2),
        marginBottom: theme.spacing(0),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
        paper: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "hidden",
        },
        logo: {
            width: '250px',
            height: '100%'
        },
        formControl: {
            width: "14rem",
            margin: theme.spacing(2),
            marginLeft: theme.spacing(0),
        },
        accOverview: {
            width: '50%',
            height: 'auto',
            paddingTop: 0,
            paddingBottom: 0,
            marginLeft: theme.spacing(5),
            marginBottom: theme.spacing(0),
            [theme.breakpoints.down('sm')]: {
                padding: 0,
                margin: 0,
                paddingRight: 0,
            },
        }
    },
});
const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}
const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ paddingTop: 1, paddingLeft: 3 * 3, paddingRight: 3 * 3, bottom: -6 }} scroll='paper'>
            {props.children}
        </Typography>
    );
};

const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

const Account = props => {
    const {
        onAccountPlansList,
        theme,
        onFetchLogos,
        classes,
        customers,
        activeCustomerId,
        onUpdateCustomer,
        userLanguage,
        accountID,
        editBillingAccount,
        onListUsers,
        onLoadAccount,
        onEditCustomer,
        editing,
        onCleanState,
        translations,
        permissions,
        onLoadCustomer,
        onLoadErasures,
        onLoadYears,
        onLoadBillingAccount
    } = props;
    const [tabValue, setTabValue] = useState(getTabValue());
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);

    const [accountData, setAccountData] = useState(null);
    const [, setYears] = useState([]);
    const [year, ] = useState(moment().year());
    const [, setErasures] = useState({erasure: [], totalErasures: 0, totalErasuresAllYears: 0, loading: false});

    const isMounted = useRef(true);

    const customerCancel = CancelToken?.source();
    const yearsCancel = CancelToken?.source();
    const erasuresCancel = CancelToken?.source();


    /* when handling mutiple accounts(Future)

    const [selectedAccountID, setSelectedAccountID] = useState(null);

    const handleChangeAcc = event => {
        setSelectedAccountID(event.target.value);
    }
    const accountSelectionDropDown = (
        <div>
            <FormControl className={classes.formControl} margin={"dense"} >
                <InputLabel shrink>{translations["account_id_select"] || "Please select account"}</InputLabel>
                <Select
                    name="accountID"
                    label={translations["account"] || 'Account'}
                    margin={"dense"}
                    value={selectedAccountID || (accountID && accountID[0]?.AccountID) || ''}
                    onChange={handleChangeAcc}
                >
                    {(accountID ?? []).map((option, index) => (
                        <MenuItem key={option.AccountID} value={option.AccountID}>
                            {option.BillingMode + index}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl></div>);
    */

    useEffect(() => {

        const fetchData = async () => {
            if (!customers.account.loading) {
                if (isMounted.current || (isMounted.current && loading)) {
                    let counter = 0;
                    let customerData = [];
                    let totalErasures = 0;
                    let totalErasuresAllYears = 0;
                    setErasures({
                        erasure: customerData,
                        totalErasures: totalErasures,
                        totalErasuresAllYears: totalErasuresAllYears,
                        loading: true
                    });

                    const years = await onLoadYears({
                        CustomerID: activeCustomerId,
                        ActiveCustomerID: activeCustomerId
                    }, {cancelToken: yearsCancel});
                    setYears(years);

                    const data = await onLoadErasures({
                        CustomerID: activeCustomerId,
                        Year: year,
                        ActiveCustomerID: activeCustomerId
                    }, {cancelToken: erasuresCancel});

                    for (var erasure in data) {
                        if (erasure === 'total') {
                            totalErasuresAllYears = data[erasure];
                            continue;
                        }
                        let returnObj = {};
                        returnObj.id = erasure;
                        returnObj.index = counter;
                        returnObj.selected = false;
                        returnObj.visible = true;
                        returnObj.values = [erasure, data[erasure].total, data[erasure].pc, data[erasure].mobile];
                        counter++;
                        customerData.push(returnObj);
                        totalErasures += data[erasure].total
                    }

                    isMounted?.current && setErasures({
                        erasure: customerData,
                        totalErasures: totalErasures,
                        totalErasuresAllYears: totalErasuresAllYears,
                        loading: false
                    });
                }
            }

        }

        isMounted.current && setLoading(false);
        isMounted.current && onLoadCustomer({
            CustomerID: activeCustomerId,
            ActiveCustomerID: activeCustomerId
        }, {cancelToken: customerCancel});
        isMounted.current && fetchData();

        return () => {
            customerCancel.cancel('Operation canceled by user');
            yearsCancel.cancel('Operation canceled by the user.');
            erasuresCancel.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line
    }, [year]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            let result = await onLoadAccount({ActiveAccountID: accountID, ActiveCustomerID: activeCustomerId});
            setAccountData(result);
            await onLoadBillingAccount({ActiveAccountID: accountID, ActiveCustomerID: activeCustomerId})
            let data = await onListUsers({ActiveCustomerID: activeCustomerId});
            setUsers(data);
            setLoading(false);
        };

        accountID && fetchData();
        return () => {
            onCleanState();
        };
    }, [onLoadAccount, onCleanState, onListUsers, accountID, activeCustomerId, onLoadBillingAccount]);


    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };

    return (
        <>
            <Paper className={classes.root}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab label={translations['customer_details'] || "Customer details"} value={0}/>
                    <Tab label={translations['billing_data'] || "Billing Data"} value={1}/>
                    {hasPermission(permissions, 'account_balance_list') && <Tab label={translations['balance'] || "Balance"} value={2}/>}
                    <Tab label={translations['plan'] || "Plans"} value={3}/>
                    <Tab label={translations['software_licenses'] || "Software licenses"} value={4}/>
                </Tabs>
            </Paper>
            {hasPermission(permissions, 'customer_load') &&
            <Paper className={classes.root}>
                <TabPanel index={0} value={tabValue}>
                    <TabContainer>
                        <CustomerEdit
                            onCleanState={onCleanState}
                            activeCustomer={activeCustomerId} permissions={permissions} customerID={activeCustomerId}
                            customer={customers?.loaded}
                            translations={translations}
                            onFetchLogos={onFetchLogos}
                            onUpdateCustomer={onUpdateCustomer}
                            setLoading={setLoading}
                            userLanguage={props.userLanguage}
                            loading={loading} onEditCustomer={onEditCustomer}
                            onLoadCustomer={onLoadCustomer}
                            accountManagement/>
                            
                    </TabContainer>
                </TabPanel>
            </Paper>}
            {hasPermission(permissions, 'billing_account_load') &&
            <TabPanel index={1} value={tabValue}>
                <TabContainer>
                    <div className={classes.accOverview}>
                        <AccountOverview
                            userLanguage={userLanguage}
                            activeCustomerID={activeCustomerId}
                            accountTab={true}
                            permissions={permissions}
                            translations={translations}
                            billingAccount={accountData?.data}
                            editBillingAccount={editBillingAccount}
                            users={users}
                            customers={customers}
                            onLoadAccount={onLoadAccount}
                            loading={editing}/>
                    </div>
                </TabContainer>
            </TabPanel>}
            {hasPermission(permissions, 'account_balance_list') &&
            <Paper className={classes.root}>
                <TabPanel index={2} value={tabValue}>
                    <TabContainer>
                        <Balance activeAccountID={accountID} isTab={true} />
                    </TabContainer>
                </TabPanel>
            </Paper>}
            {hasPermission(permissions, 'billing_account_plan_list') &&
            <TabPanel index={3} value={tabValue}>
                <TabContainer style={{paddingLeft: 6, paddingRight: 6}} dir={theme.direction}>
                    <Suspense fallback={<div><CircularProgress/></div>}>
                        <PlanList activeCustomerID={activeCustomerId} translations={translations}
                                  onAssignPlans={props.onAssignPlans} onLoadAccount={onLoadAccount}
                                  onListPlans={props.onListPlans} extraFilterParams={{ ActiveAccountID: accountID }}
                                  permissions={permissions} onAccountPlansList={onAccountPlansList}
                                  removePlans={props.removePlans} />
                    </Suspense>
                </TabContainer>
            </TabPanel>}
            {hasPermission(permissions, 'software_license_list') &&
            <TabPanel index={4} value={tabValue}>
                <TabContainer style={{paddingLeft: 6, paddingRight: 6}} dir={theme.direction}>
                    <Suspense fallback={<div><CircularProgress/></div>}>
                        <SoftwareLicenseList activeCustomerID={activeCustomerId} extraFilterParams={{ ActiveAccountID: accountID }}
                                             translations={translations} permissions={permissions}/>
                    </Suspense>
                </TabContainer>
            </TabPanel>}
        </>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomerId: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        customers: state?.customer?.customers,
        translations: state?.translate?.translations?.activeTranslations || {},
        permissions: state?.core?.login?.permissions || [],
        billingAccount: state.billing.accounts ? state.billing.accounts.loaded : null,
        editing: state.billing.accounts ? state.billing.accounts.editing : false,
        accountID: state?.customer?.customers?.loaded?.Accounts[0]?.AccountID,
        userLanguage: state?.core?.login?.userSettings?.DefaultLanguage,
        columns: state?.core?.login?.userSettings?.Columns || null,
        account: state?.billing?.accounts,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchLogos: (id) => dispatch(actions.fetchLogos(id)),
        editBillingAccount: params => dispatch(billingAccountActions.editBillingAccount(params)),
        onLoadAccount: params => dispatch(prepaidBalanceActions.onLoadAccount(params)),
        onLoadBillingAccount: params => dispatch(billingActions.loadBillingAccount(params)),
        onEditCustomer: customerID => dispatch(actions.editCustomer(customerID)),
        onUpdateCustomer: (customer, options) => dispatch(actions.updateCustomer(customer, options)),
        onCleanState: () => dispatch(actions.cleanState()),
        onLoadCustomer: (customerID, options) => dispatch(actions.loadCustomer(customerID, options)),
        onFetchCustomers: customerID => dispatch(actions.fetchCustomers(customerID)),
        onDeleteBillingAccount: billingAccount => dispatch(billingActions.deleteBillingAccount(billingAccount)),
        onSuspend: billingAccountID => dispatch(actions.suspendBillingPlan(billingAccountID)),
        onRecover: billingAccountID => dispatch(actions.recoverBillingPlan(billingAccountID)),
        onListCustomers: (options) => dispatch(billingActions.listCustomers(options)),
        onListUsers: (id, options) => dispatch(billingActions.listUsers(id, options)),
        onCreateBillingAccount: billingAccount => dispatch(billingActions.createBillingAccount(billingAccount)),
        onLoadYears: customerID => dispatch(actions.fetchYears(customerID)),
        onLoadErasures: customerID => dispatch(actions.fetchErasures(customerID)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onAccountPlansList: params => dispatch(billingActions.onAccountPlansList(params)),
        removePlans: params => dispatch(billingActions.removePlans(params)),
        onListPlans: id => dispatch(billingActions.listPlans(id)),
        onAssignPlans: billingAccount => dispatch(billingActions.assignPlans(billingAccount)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(Account));
